/**
 * @author Evgenij.Tyan
 * @version 1.0.1
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors, fonts } from '../../../../../../theme';
import { IAttrStyled } from '../../../../../../types/globalTypes';

export const SaveAsButtonStyled = styled.div.attrs((props: IAttrStyled) => ({
    'className': `ext-filter__action-button save-as-button ${props.className || ''}`,
    'id': 'ext-filter-save-as-button',
    'data-extended-filter-save-as-button': 'extendedFilterSaveAsButton',
}))`
    ${fonts.textLink};
    cursor: pointer;
    margin-left: 16px;
    position: relative;
`;

export const SaveAsModalContainerStyled = styled.div.attrs({
    className: 'save-as-button__modal-window',
})`
    position: absolute;
    background: ${colors.backgroundColorWhite};
    padding: 16px;
    width: 312px;
    z-index: 10;
    box-shadow: 0 2px 12px 0 ${colors.textColorOpacity};
    & .save-as-button__save-button {
        height: 32px;
        margin-top: 16px;
        & button {
            min-height: 32px;
        }
    }
`;
